import VMasker from 'vanilla-masker';

// Permite so numeros inteiros
// Usar em onKeyPress(ev)
export function onlyIntegerNumber(evt) {
  const theEvent = evt || window.event;
  let key = theEvent.keyCode || theEvent.which;
  key = String.fromCharCode(key);
  const regex = /^[0-9]+$/;
  if (!regex.test(key)) {
    theEvent.returnValue = false;
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
}

export function parseIntLocaleString(value) {
  return parseInt(value, 10).toLocaleString('pt-BR');
}

export function formatarMoeda(valor) {
  return `${valor.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
  })}`;
}

export function formatarTelefone(valor) {
  const numeroLimpo = VMasker.toPattern(valor, '99999999999999999999');
  const mascara =
    numeroLimpo.length > 10 ? '(99) 99999-9999' : '(99) 9999-9999';

  return VMasker.toPattern(numeroLimpo, mascara);
}

export default onlyIntegerNumber;
